export function emitLoadingStart(filePath, options = {}) {
  window.dispatchEvent(new CustomEvent('global-loading-start', {
    detail: { filePath, ...options },
  }));
}

export function emitLoadingProgress(filePath, percentage) {
  window.dispatchEvent(new CustomEvent('global-loading-progress', { detail: { filePath, percentage } }));
}

export function emitLoadingEnd(filePath) {
  window.dispatchEvent(new CustomEvent('global-loading-end', { detail: { filePath } }));
}
